import React from 'react';
import PropTypes from 'prop-types';

const Pending = ({ fill = '#D68309', size = '' }) => {
  switch (size) {
    case 'lg':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <circle cx="24" cy="24" r="24" fill={fill} />
          <path
            d="M24.0224 29.0371C22.9445 29.0371 22.041 29.9406 22.041 31.0185C22.041 32.0964 22.9445 32.9999 24.0224 32.9999C25.0607 32.9999 26.0038 32.0964 25.9562 31.0661C26.0038 29.9327 25.1082 29.0371 24.0224 29.0371Z"
            fill="white"
          />
          <path
            d="M23.5296 14.0559C22.5865 14.3254 22 15.1814 22 16.2196C22.0476 16.8457 22.0872 17.4798 22.1347 18.1059C22.2695 20.4915 22.4042 22.8295 22.5389 25.2151C22.5865 26.0235 23.2126 26.61 24.021 26.61C24.8294 26.61 25.4635 25.9839 25.5031 25.1676C25.5031 24.6762 25.5031 24.2244 25.5507 23.7251C25.6378 22.1955 25.7329 20.6659 25.8201 19.1362C25.8677 18.1455 25.9549 17.1548 26.0024 16.1641C26.0024 15.8075 25.9549 15.4905 25.8201 15.1734C25.4159 14.2858 24.4728 13.834 23.5296 14.0559Z"
            fill="white"
          />
        </svg>
      );
    case 'md':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle cx="12" cy="12" r="12" fill={fill} />
          <path
            d="M12.0112 14.5186C11.4723 14.5186 11.0205 14.9703 11.0205 15.5093C11.0205 16.0482 11.4723 16.4999 12.0112 16.4999C12.5303 16.4999 13.0019 16.0482 12.9781 15.533C13.0019 14.9663 12.5541 14.5186 12.0112 14.5186Z"
            fill="white"
          />
          <path
            d="M11.7648 7.02797C11.2932 7.1627 11 7.59068 11 8.10981C11.0238 8.42287 11.0436 8.73989 11.0674 9.05295C11.1347 10.2457 11.2021 11.4148 11.2695 12.6076C11.2932 13.0118 11.6063 13.305 12.0105 13.305C12.4147 13.305 12.7317 12.992 12.7515 12.5838C12.7515 12.3381 12.7515 12.1122 12.7753 11.8626C12.8189 11.0977 12.8665 10.3329 12.9101 9.56811C12.9338 9.07276 12.9774 8.57742 13.0012 8.08207C13.0012 7.90374 12.9774 7.74523 12.9101 7.58672C12.708 7.14289 12.2364 6.91701 11.7648 7.02797Z"
            fill="white"
          />
        </svg>
      );
    case 'sm':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <circle cx="6" cy="6" r="6" fill={fill} />
          <path
            d="M6.00511 7.25928C5.73564 7.25928 5.50977 7.48516 5.50977 7.75463C5.50977 8.02409 5.73564 8.24997 6.00511 8.24997C6.26468 8.24997 6.50046 8.02409 6.48857 7.76651C6.50046 7.48317 6.27656 7.25928 6.00511 7.25928Z"
            fill="white"
          />
          <path
            d="M5.88241 3.51398C5.64662 3.58135 5.5 3.79534 5.5 4.0549C5.51189 4.21143 5.5218 4.36995 5.53368 4.52648C5.56737 5.12287 5.60105 5.70738 5.63473 6.30378C5.64662 6.50588 5.80315 6.65251 6.00525 6.65251C6.20736 6.65251 6.36587 6.49598 6.37577 6.29189C6.37577 6.16905 6.37577 6.05611 6.38766 5.93128C6.40946 5.54887 6.43324 5.16646 6.45503 4.78406C6.46692 4.53638 6.48871 4.28871 6.5006 4.04103C6.5006 3.95187 6.48871 3.87262 6.45503 3.79336C6.35398 3.57144 6.11819 3.45851 5.88241 3.51398Z"
            fill="white"
          />
        </svg>
      );
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
            fill="white"
          />
          <path
            d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9Z"
            fill="#F2F2F2"
          />
          <path
            d="M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
            fill={fill}
          />
          <path
            d="M9.00721 10.6791C8.64791 10.6791 8.34674 10.9803 8.34674 11.3395C8.34674 11.6988 8.64791 12 9.00721 12C9.35329 12 9.66767 11.6988 9.65182 11.3554C9.66767 10.9776 9.36914 10.6791 9.00721 10.6791Z"
            fill="white"
          />
          <path
            d="M8.84322 5.68535C8.52884 5.77517 8.33334 6.0605 8.33334 6.40658C8.34919 6.61529 8.3624 6.82663 8.37825 7.03534C8.42316 7.83054 8.46808 8.60989 8.51299 9.40508C8.52884 9.67455 8.73755 9.87005 9.00701 9.87005C9.27648 9.87005 9.48783 9.66134 9.50104 9.38923C9.50104 9.22544 9.50104 9.07485 9.51689 8.90841C9.54595 8.39854 9.57765 7.88866 9.60672 7.37878C9.62257 7.04855 9.65163 6.71832 9.66748 6.38809C9.66748 6.2692 9.65163 6.16353 9.60672 6.05785C9.47198 5.76197 9.1576 5.61138 8.84322 5.68535Z"
            fill="white"
          />
        </svg>
      );
  }
};

Pending.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string,
};

export default Pending;
